import React from "react";
import styles from "./index.module.scss";
import classNames from "classnames";

interface IProps {
  className?: string;
  buyPaths: Record<string, any>[];
  words: Record<string, string>;
  btnStyle?: string | number;
}

const BuyButton = (props:IProps) => {
  const { words, className, buyPaths, btnStyle } = props;
  const btnType = btnStyle ? String(btnStyle) : '0';
  const buyClick = (item:Record<string, any>) => {
    if (item.buyPath) {
      window.open(item.buyPath, '_blank');
    }
  }

  return (
    <>
      {buyPaths && buyPaths.length > 0  && (
        <div className={styles['buy-btn-wrap']}>
          {buyPaths.length > 1 ? (
            <>
              <span className={classNames(
                className,
                {[styles['purple-primary']]: btnType === '0'},
                {[styles['purple-line']]: btnType === '1'}
              )}>
                  {words?.blog_buy_now}
              </span>
              <div className={styles['buy-links']}>
                {buyPaths.map((item: Record<string, any>, index) => {
                  return <div className={styles['link-item']} key={item.id || index}><img src={item?.url} alt={item?.alt} onClick={() => buyClick(item)} /></div>
                })}
              </div>
            </>
          ) : (
            <span
              onClick={() => buyClick(buyPaths[0])}
              className={classNames(
                className,
                {[styles['purple-primary']]: btnType === '0'},
                {[styles['purple-line']]: btnType === '1'}
              )} >
                {words?.blog_buy_now}
            </span>
          )}
        </div>
      )}
    </>
  )
}

export default BuyButton;